import React from 'react';

const About = () => {
    return (
        <div className="container py-5">
            <div className="text-center mb-5">
                <h1 className="display-4 fw-bold gradient-text">About Us</h1>
                <p className="lead">Learn more about aditya birla finance capital and our commitment to excellence.</p>
            </div>

            <div className="row align-items-center">
                <div className="col-md-6 mb-4 mb-md-0">
                    <img 
                        src="./about.webp" 
                        alt="aditya birla finance capital" 
                        className="img-fluid rounded shadow" 
                    />
                </div>
                <div className="col-md-6">
                    <h2 className="fw-bold mb-3">Who We Are</h2>
                    <p>
                        aditya birla finance capital, a part of the Aditya Birla Group, is one of India’s leading non-banking financial companies (NBFC). 
                        We specialize in providing a wide array of financial solutions, including loans, insurance, and investment opportunities.
                        Our mission is to empower individuals and businesses by providing reliable financial services tailored to their needs.
                    </p>

                    <h3 className="fw-bold mt-4">Our Services</h3>
                    <ul>
                        <li>Comprehensive insurance plans for individuals and families.</li>
                        <li>Flexible loan options for personal and business needs.</li>
                        <li>Wealth management and investment services.</li>
                        <li>Customizable financial solutions with a customer-first approach.</li>
                    </ul>
                </div>
            </div>

            <div className="mt-5">
                <h2 className="text-center fw-bold mb-4">Why Choose Us?</h2>
                <div className="row">
                    <div className="col-md-4">
                        <div className="card shadow h-100">
                            <div className="card-body text-center">
                                <h5 className="card-title fw-bold">Trust & Transparency</h5>
                                <p className="card-text">We operate with utmost integrity, ensuring transparency in every transaction.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card shadow h-100">
                            <div className="card-body text-center">
                                <h5 className="card-title fw-bold">Innovative Solutions</h5>
                                <p className="card-text">Our solutions are designed to meet the ever-evolving financial needs of our clients.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="card shadow h-100">
                            <div className="card-body text-center">
                                <h5 className="card-title fw-bold">Customer-Centric Approach</h5>
                                <p className="card-text">Your success is our priority. We tailor our services to match your goals.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
